import type { SVGProps } from 'react';
const SvgIconHeartSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} {...props}>
    <path
      fill="none"
      stroke="#1A202C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.44 5.353a4.1 4.1 0 0 0-2.833-1.122 4.1 4.1 0 0 0-2.835 1.122L11 6.09l-.773-.738c-1.565-1.496-4.103-1.496-5.668 0a3.71 3.71 0 0 0 0 5.416l.772.738L11 16.923l5.669-5.416.772-.738a3.74 3.74 0 0 0 1.174-2.708c0-1.016-.422-1.99-1.174-2.708z"
    />
  </svg>
);
export default SvgIconHeartSmall;
